import React from 'react';
import Sticky from 'react-sticky-el';
import video1 from 'images/landing_small_1.jpg'
// import video2 from 'images/landing_small_2.jpg'
import VideoPreview from '../../core/components/videoPreview';
import Dialog from 'material-ui/Dialog';
// import Player from '@vimeo/player';
import {Link} from 'react-router-dom';

export default class SampleTutorials extends React.Component {
  state = {
    open: false,
    url: null,
    isPlaying : false
  };

  handleOpen = (url) => {
    // this.setState({open: true, url: url+'/?autoplay=1',  isPlaying : true});
  };

  handleClose = () => {
    this.setState({open: false, url: null,  isPlaying : false});
  };


  render() {
    const videosArray = [{
      placeholder: {
        img: video1,
        alt: 'video'
      },
      url: 'https://player.vimeo.com/video/343460445', //'https://player.vimeo.com/video/239662684',
      title: '', //'Asthma Sample',
      time: ''
    }];

    const videoItem = videosArray.map((item, index) => {
      return (
        <div className="col-10 col-md-6" key={index}>
          <Link
            // to={`/topic/${11}`}
            to={'/sample-podcasts'}
          >
          <VideoPreview
            placeholder={item.placeholder}
            title={item.title}
            time={item.time}
            isLanding={true}
            // url={item.url}
            played={true}
            openPopupLanding={this.handleOpen}/>
          </Link>
          {/* <Dialog
            className="modal-wrapper"
            bodyClassName="sample-body-player"
            modal={true}
            open={this.state.open}
          >
            <form className="video-popup form-modal" name="video-popup">
              <button className="btn  transparanted cancel-btn" type="reset"
                      onClick={this.handleClose}>
                <i className="ic ic-close-circle"/>
              </button>
              {this.state.url &&
                <iframe src={`${this.state.url}`}
                        className="sample-tutorial"
                        frameBorder="0"
                        allowFullScreen
                        width="640"
                        height="360"
                        allow="autoplay; fullscreen"
                />
              }
            </form>
          </Dialog> */}
        </div>
      )
    });

    return (
      <div className="sticky-wrap">
        <Sticky>
          <section className='section sample-tuts justify-content-center'>
            <div className="col-md-8">
              <div className="content-wrap">
                <h1 className="section-title">
                  SAMPLE PODCASTS
                </h1>
                <div className="row justify-content-center">
                  {videoItem}
                </div>
                <div className="button-set">
                  <Link to="/topics">
                    <button className="btn navy bordered rounded">VIEW ALL TOPICS</button>
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </Sticky>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/landing/components/SampleTutorials.js